(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

			const new_swiper = new Swiper('#sf_product_image_slider', {
              // Optional parameters
              direction: 'horizontal',
              loop: true,
              preloadImages: false,
              lazy: true,
              // Navigation arrows
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });

			setTimeout(function(){
				$(".product-recommendations__slider").slick({

                  // normal options...
                  infinite: false,
				 
				  slidesToShow: 4,
				  adaptiveHeight: true,
				  prevArrow: `<button class="slick-prev slick-arrow" type="button" style=""></button>`,
   				  nextArrow: `<button class="slick-next slick-arrow" type="button" style=""></button>`,
                  // the magic
                  responsive: [{
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 4
                      }
                    }, {

                      breakpoint: 900,
                      settings: {
                        slidesToShow: 3
                      }
                    }, {

                      breakpoint: 600,
                      settings: {
						slidesToShow: 1
					  }
				  }]
                });
			},200);
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
